module.exports = __webpack_public_path__ + "img/product_4.557ad2c6.jpg";